import React from 'react';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

const FONT_STACKS = {
  system_sans: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  serif_display: 'Georgia, Cambria, "Times New Roman", Times, serif',
  condensed_bold: '"Arial Narrow", "Helvetica Neue", Roboto, sans-serif',
};

const darken = (hex, amt = 0.15) => {
  try {
    const h = hex.replace('#', '');
    const n = h.length === 3 ? h.split('').map((x) => x + x).join('') : h;
    const r = Math.max(0, Math.round(parseInt(n.slice(0, 2), 16) * (1 - amt)));
    const g = Math.max(0, Math.round(parseInt(n.slice(2, 4), 16) * (1 - amt)));
    const b = Math.max(0, Math.round(parseInt(n.slice(4, 6), 16) * (1 - amt)));
    return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
  } catch { return hex; }
};

const BTN_RADIUS = { rounded: '0.375rem', pill: '9999px', square: '0px' };

// Injects global design tokens as a <style> tag so admin colour/font choices
// propagate across the whole public site without editing component code.
export default function DesignStyleInjector() {
  const { theme } = useSiteSettings();
  const d = theme?.design;
  if (!d) return null;

  const accent = d.accent_color || '#dc2626';
  const accentHover = darken(accent, 0.15);
  const bodyFont = FONT_STACKS[d.body_font] || FONT_STACKS.system_sans;
  const headingFont = FONT_STACKS[d.heading_font] || FONT_STACKS.system_sans;
  const btnRadius = BTN_RADIUS[d.button_style] || BTN_RADIUS.rounded;

  const css = `
:root{
  --ta-primary:${d.primary_color || '#0f172a'};
  --ta-secondary:${d.secondary_color || '#f8fafc'};
  --ta-accent:${accent};
  --ta-neutral:${d.neutral_color || '#334155'};
}
body{font-family:${bodyFont};}
h1,h2,h3,.ta-heading{font-family:${headingFont};}
.bg-red-600{background-color:${accent} !important;}
.hover\\:bg-red-700:hover,.hover\\:bg-red-700:focus{background-color:${accentHover} !important;}
.text-red-500,.text-red-600,.text-red-400{color:${accent} !important;}
.border-red-600,.border-red-500{border-color:${accent} !important;}
.bg-red-600{border-radius:${btnRadius};}
`;
  return <style data-testid="design-style-injector" dangerouslySetInnerHTML={{ __html: css }} />;
}
